/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Form_Validation_Min_LengthInputs */



/**
* | output |
* | --- |
* | "Minimum length is {min} characters" |
*
* @param {Form_Validation_Min_LengthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_validation_min_length = /** @type {((inputs: Form_Validation_Min_LengthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Validation_Min_LengthInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Muss mindestens ${i?.min} Zeichen lang sein`)
	return /** @type {LocalizedString} */ (`Minimum length is ${i?.min} characters`)
});